import 'reflect-metadata'
import { define, type, auto, Record, Collection } from 'type-r'
import { openDB, deleteDB } from 'idb';

import Store from './store.js'

import PatientForm from '#forms/patient.js'
import FinancialPolicyForm from '#forms/financial_policy.js'
import AuthorizationDisclosureForm from '#forms/authorization_disclosure.js'
import CancellationPolicyForm from '#forms/cancellation_policy.js'

@define
export default class OneformStore extends Store {
    @(type(PatientForm).events({"change": "formchange"}).as) patientForm: PatientForm
    @(type(AuthorizationDisclosureForm).events({"change": "formchange"}).as) authorizationDisclosureForm: AuthorizationDisclosureForm
    @(type(CancellationPolicyForm).events({"change": "formchange"}).as) cancellationPolicyForm: CancellationPolicyForm
    @(type(FinancialPolicyForm).events({"change": "formchange"}).as) financialPolicyForm: FinancialPolicyForm
}

const store = window.store = new OneformStore({ id: "oneform" })
export { store };
